/* ==========================================================================
   Dynoforce datalaag
   Dit is de enige plek waar voertuigdata vandaan komt. Nu mockdata, later
   een echte bron. Om over te stappen zet je ENDPOINTS hieronder op je app
   proxy en verandert er verder niets in het thema.

     window.DFData.getVehicleTree()      -> boom voor de auto-finder
     window.DFData.lookupPlate('GX001B') -> voertuig plus vermogenscijfers

   Let op de statuscodes: 200 met status "meerdere" is geen misser maar
   een keuze - het antwoord draagt dan een lijst uitvoeringen, elk met
   eigen vermogen en koppel. 404 en 429 hebben ook een leesbaar lichaam;
   status zegt waarom. Nooit alleen op de code afgaan.

   Beide geven een Promise terug en gooien een Error met een leesbare
   Nederlandse melding als het misgaat.
   ========================================================================== */

window.DFData = (function () {
  'use strict';

  /* Zolang een waarde null is, gebruikt het thema de mockdata eronder.
     De kentekenlookup gaat via de app proxy; de modellenboom voor de
     auto-finder draait nog op mockdata.                                     */
  var ENDPOINTS = {
    tree: null,
    plate: '/apps/kentekencheck'
  };

  /* ---------- Kenmerk per bezoeker ---------------------------------------
     Shopify draait de app proxy op Cloudflare en stuurt het ip-adres van de
     bezoeker niet door - nagemeten aan de kant van het platform, het staat in
     geen enkele doorgestuurde kop. Zonder eigen kenmerk kan het platform
     bezoekers dus niet uit elkaar houden en geldt alleen de grens voor de hele
     winkel (200 per uur). Met deze sessie erbij gelden ook de 30 per uur en 60
     per dag per bezoeker.

     Het is geen beveiliging en hoeft niet geheim te zijn: wie eronderuit wil,
     wist hem gewoon en verzint een nieuwe. Het houdt normaal doorklikken en
     een script in een lus tegen, en voorkomt dat een enkele bezoeker de
     winkelgrens in zijn eentje opmaakt.

     De waarde is willekeurig en is nergens van afgeleid: hij zegt niets over
     wie de bezoeker is.                                                     */
  var SESSIE_SLEUTEL = 'df_sessie';
  var sessieInGeheugen = null;

  function nieuweSessie() {
    if (window.crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    /* Safari kent randomUUID pas vanaf 15.4, dus daar zelf 16 bytes trekken. */
    if (window.crypto && typeof crypto.getRandomValues === 'function') {
      var bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      var hex = '';
      for (var i = 0; i < bytes.length; i++) {
        hex += (bytes[i] + 0x100).toString(16).slice(1);
      }
      return hex;
    }
    return 'df' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
  }

  function sessie() {
    if (sessieInGeheugen) return sessieInGeheugen;
    /* localStorage gooit in de priveweergave van Safari en als de bezoeker
       opslag heeft geblokkeerd. Lukt het niet, dan houden we de sessie alleen
       deze paginaweergave vast. Minder waard, maar een script in een lus loopt
       er nog steeds op stuk. */
    try {
      var bewaard = localStorage.getItem(SESSIE_SLEUTEL);
      if (bewaard) {
        sessieInGeheugen = bewaard;
        return bewaard;
      }
    } catch (e) { /* opslag niet beschikbaar */ }

    sessieInGeheugen = nieuweSessie();
    try {
      localStorage.setItem(SESSIE_SLEUTEL, sessieInGeheugen);
    } catch (e) { /* opslag niet beschikbaar */ }
    return sessieInGeheugen;
  }

  /* ---------- Mock: modellenboom voor de auto-finder ---------------------- */
  var MOCK_TREE = {
    'BMW': {
      '1 Serie': { 'F40 (2019+)': ['118i', '128ti', 'M135i xDrive'] },
      '3 Serie': { 'G20 (2019+)': ['320i', '330i', 'M340i xDrive'], 'F30 (2012-2019)': ['320i', '328i', '335i'] },
      'M3': { 'G80 (2021+)': ['M3', 'M3 Competition'], 'F80 (2014-2018)': ['M3'] },
      'M4': { 'G82 (2021+)': ['M4', 'M4 Competition'] },
      'X3M': { 'F97 (2019+)': ['X3M', 'X3M Competition'] },
      'X4M': { 'F98 (2019+)': ['X4M', 'X4M Competition'] },
      'X5': { 'G05 (2018+)': ['xDrive40i', 'M50i'] },
      'X6': { 'G06 (2019+)': ['xDrive40i', 'M50i'] }
    },
    'Audi': {
      'A3': { '8Y (2020+)': ['30 TFSI', '35 TFSI', 'S3'], '8V (2012-2020)': ['1.4 TFSI', '2.0 TFSI', 'S3'] },
      'RS3': { '8Y (2021+)': ['RS3'] },
      'A4': { 'B9 (2015+)': ['35 TFSI', '40 TFSI', 'S4'] },
      'RS6': { 'C8 (2019+)': ['RS6 Avant'] },
      'Q5': { 'FY (2017+)': ['40 TFSI', 'SQ5'] }
    },
    'Volkswagen': {
      'Golf': { '8 (2020+)': ['1.5 TSI', 'GTI', 'R'], '7.5 (2017-2020)': ['GTI', 'R'] },
      'Polo': { 'AW (2017+)': ['1.0 TSI', 'GTI'] },
      'Tiguan': { 'AD (2016+)': ['1.5 TSI', '2.0 TSI'] }
    },
    'Mercedes-Benz': {
      'A-Klasse': { 'W177 (2018+)': ['A 200', 'A 250', 'A 35 AMG', 'A 45 AMG'] },
      'C-Klasse': { 'W205 (2014-2021)': ['C 200', 'C 300', 'C 43 AMG', 'C 63 AMG'] },
      'CLA': { 'C118 (2019+)': ['CLA 200', 'CLA 35 AMG'] }
    }
  };

  var treeCache = null;

  /**
   * Modellenboom: { merk: { model: { generatie: [motorisering, ...] } } }
   * @returns {Promise<Object>}
   */
  function getVehicleTree() {
    if (treeCache) return Promise.resolve(treeCache);

    if (!ENDPOINTS.tree) {
      treeCache = MOCK_TREE;
      return Promise.resolve(treeCache);
    }

    return fetch(ENDPOINTS.tree, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('De modellenlijst is even niet bereikbaar.');
        return r.json();
      })
      .then(function (data) {
        treeCache = data;
        return data;
      });
  }

  /**
   * Kentekenopzoeking.
   * Geeft null terug als het kenteken niet gevonden is; dat is geen fout.
   *
   * @param {string} plate  kenteken met of zonder streepjes
   * @returns {Promise<null|{
   *   kenteken:string, merk:string, model:string, motorisering:string,
   *   bouwjaar:(number|null), brandstof:string, afbeelding:(string|null),
   *   vermogen:{origineel:number, stage1:number, eenheid:'pk'},
   *   koppel:{origineel:number, stage1:number, eenheid:'Nm'}
   * }>}
   */
  /* ---------- Antwoorden onthouden ---------------------------------------
     Een opvraging duurt ongeveer twee seconden, en de eerste keer dat de
     dienst een bepaalde auto ziet ruim drie. Dat is geen fout maar de
     ondergrens: koud opstarten, limietcontrole, tuninglijst doorzoeken.

     Hetzelfde kenteken twee keer opvragen kost dus twee seconden die niemand
     hoeft te wachten, en het telt dubbel mee voor de limieten en voor het
     fotoquotum. Vandaar dit geheugen.

     In sessionStorage, zodat het ook werkt als de bezoeker terugklikt en weer
     verder gaat. Maar met een datumstempel erbij: de fotolinks in het antwoord
     zijn ondertekend en verlopen om middernacht UTC. Wisselt de UTC-dag, dan
     gooien we alles weg in plaats van iemand vier kapotte foto's voor te
     schotelen.                                                              */
  var GEHEUGEN = 'df_kt_geheugen';
  var geheugenNu = {};

  function utcDag() {
    var d = new Date();
    return d.getUTCFullYear() + '-' + (d.getUTCMonth() + 1) + '-' + d.getUTCDate();
  }

  function geheugenLees(kt) {
    if (geheugenNu[kt]) return geheugenNu[kt];
    try {
      var ruw = sessionStorage.getItem(GEHEUGEN);
      if (!ruw) return null;
      var pot = JSON.parse(ruw);
      if (!pot || pot.dag !== utcDag()) {
        sessionStorage.removeItem(GEHEUGEN);
        return null;
      }
      return pot.items && pot.items[kt] ? pot.items[kt] : null;
    } catch (e) { return null; }
  }

  /* Het laatst opgezochte kenteken apart bewaren. Daarmee kan een volgende
     pagina met een kentekenveld zichzelf invullen, ook als er geen ?kenteken=
     in de link stond. Dat gebeurt bijvoorbeeld bij de knop van chiptuning naar
     Bootmod3: die staat buiten de resultaatkaart en krijgt dus geen parameter
     mee. */
  var LAATSTE = 'df_kt_laatste';

  function laatsteKenteken() {
    try { return sessionStorage.getItem(LAATSTE) || ''; } catch (e) { return ''; }
  }

  /* ---------- Sitebreed onthouden ----------------------------------------
     Het laatst opgezochte kenteken hoort langer mee te gaan dan deze tab.
     Elke plaat op de site vult zich hiermee voor in, en de rekenkaarten
     tekenen het antwoord er direct uit zonder nieuwe opvraging. Dertig dagen
     in localStorage, onder df_kenteken:

       { kt: 'N-948-PD', v: <volledig zeker-antwoord of null>,
         auto: { merk, model, bouwjaar } of null, ts: <ms> }

     auto is de lichte identiteit uit elk antwoord dat merk of model noemt,
     ook bij meerdere uitvoeringen, kan_wel en een EV zonder tuningcijfers
     (K8, 16-10-2026). De productpagina zet daar "Jouw auto" mee neer; de
     rekenkaarten blijven op v leunen, dat verandert hier niet.

     Dit is de plek waar het schrijven gebeurt, want elke opvraging op de site
     loopt hierlangs. Zo onthoudt ook een pagina met een eigen afhandeling het
     kenteken - de motorkiezer op de Bootmod3-pagina slaat df-kenteken.js
     bijvoorbeeld over. De weergavekant (df-kenteken.js, df-auto.js) leest
     dezelfde sleutel.

     Een antwoord zonder cijfers overschrijft een eerder volledig antwoord van
     hetzelfde kenteken niet: bij meerdere uitvoeringen, bij een storing en bij
     de limiet blijft staan wat we al wisten.

     Blokkeert de browser localStorage - priveweergave, opslag uit, of een
     ingesloten weergave onder een ander domein zoals de thema-editor - dan
     valt hij terug op sessionStorage en anders op het geheugen van deze
     paginaweergave. Het onthouden reikt dan minder ver, maar er gaat nergens
     iets stuk.                                                              */
  var LANG_SLEUTEL = 'df_kenteken';
  var LANG_HOUDBAAR = 30 * 24 * 60 * 60 * 1000;
  var langInGeheugen = null;

  function langHaal() {
    try {
      var r = localStorage.getItem(LANG_SLEUTEL);
      if (r) return r;
    } catch (e) { /* opslag niet beschikbaar */ }
    try {
      var s = sessionStorage.getItem(LANG_SLEUTEL);
      if (s) return s;
    } catch (e) { /* opslag niet beschikbaar */ }
    return langInGeheugen;
  }

  function langZet(ruw) {
    langInGeheugen = ruw;
    try { localStorage.setItem(LANG_SLEUTEL, ruw); return; } catch (e) { /* verder */ }
    try { sessionStorage.setItem(LANG_SLEUTEL, ruw); } catch (e) { /* alleen geheugen */ }
  }

  function onthoudenKenteken() {
    try {
      var r = JSON.parse(langHaal() || 'null');
      if (!r || !r.kt || !r.ts || Date.now() - r.ts > LANG_HOUDBAAR) return null;
      return r;
    } catch (e) { return null; }
  }

  /* Genoeg om er later een rekenkaart mee te tekenen: vier echte getallen.
     Bij meerdere uitvoeringen is de keuze nog niet gemaakt en zeggen de
     cijfers bovenaan niets; die bewaren we dus niet. Een uitvoering die de
     bezoeker daarna aanklikt komt hier wel binnen - die draagt zijn eigen
     cijfers en geen lijst meer. */
  function genoegVoorKaart(v) {
    if (!v || !v.vermogen || !v.koppel) return false;
    if (typeof v.vermogen.origineel !== 'number' || typeof v.vermogen.stage1 !== 'number') return false;
    if (typeof v.koppel.origineel !== 'number' || typeof v.koppel.stage1 !== 'number') return false;
    if (v.status === 'meerdere') return false;
    if (v.uitvoeringen && v.uitvoeringen.length) return false;
    return true;
  }

  /* De lichte identiteit: merk, model en bouwjaar, uit elk antwoord dat
     merk of model noemt. Geen cijfers, geen kenteken. */
  function autoUit(antwoord) {
    if (!antwoord || typeof antwoord !== 'object') return null;
    if (!antwoord.merk && !antwoord.model) return null;
    return {
      merk: antwoord.merk || '',
      model: antwoord.model || '',
      bouwjaar: antwoord.bouwjaar || null
    };
  }

  function zelfdeAuto(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    return a.merk === b.merk && a.model === b.model && a.bouwjaar === b.bouwjaar;
  }

  function onthoud(kt, antwoord) {
    var net = formatPlate(kt);
    if (!net) return;
    var v = genoegVoorKaart(antwoord) ? antwoord : null;
    var auto = autoUit(antwoord);
    var oud = onthoudenKenteken();
    if (!v && oud && oud.kt === net && oud.v) v = oud.v;
    if (!auto && oud && oud.kt === net && oud.auto) auto = oud.auto;
    /* Verandert er niets aan de auto, dan alleen de datum verversen en verder
       zwijgen. Anders zou een sectie die op het bericht zijn kaart tekent en
       daarbij weer opslaat, zichzelf aan de praat houden. Blijft v leeg maar
       komt er wel een auto bij (een EV, meerdere uitvoeringen), dan is dat
       wel nieuws: de productpagina zet er "Jouw auto" mee neer. */
    var zelfde = !!(oud && oud.kt === net && !!oud.v === !!v && zelfdeAuto(oud.auto || null, auto));
    langZet(JSON.stringify({ kt: net, v: v, auto: auto, ts: Date.now() }));
    if (zelfde) return;
    /* De andere platen op dezelfde pagina volgen dit bericht, zodat er nooit
       twee velden met verschillende kentekens naast elkaar staan. */
    try {
      document.dispatchEvent(new CustomEvent('df:kenteken', { detail: { kt: net, v: v, auto: auto } }));
    } catch (e) { /* browser zonder CustomEvent-constructor */ }
  }

  function geheugenSchrijf(kt, antwoord) {
    try { sessionStorage.setItem(LAATSTE, kt); } catch (e) { /* geen opslag */ }
    geheugenNu[kt] = antwoord;
    try {
      var ruw = sessionStorage.getItem(GEHEUGEN);
      var pot = ruw ? JSON.parse(ruw) : null;
      if (!pot || pot.dag !== utcDag()) pot = { dag: utcDag(), items: {} };
      pot.items[kt] = antwoord;
      sessionStorage.setItem(GEHEUGEN, JSON.stringify(pot));
    } catch (e) { /* opslag niet beschikbaar; het geheugen in deze
                     paginaweergave werkt nog wel */ }
    onthoud(kt, antwoord);
  }

  function lookupPlate(plate) {
    var normalized = String(plate || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (normalized.length < 6) {
      return Promise.reject(new Error('Vul een volledig kenteken in.'));
    }

    if (!ENDPOINTS.plate) {
      return new Promise(function (resolve) {
        // Kleine vertraging zodat de scananimatie in het ontwerp klopt.
        setTimeout(function () { resolve(mockVehicle(normalized)); }, 1100);
      });
    }

    var onthouden = geheugenLees(normalized);
    if (onthouden) {
      /* Uit het geheugen van deze sessie, maar evengoed het kenteken van deze
         bezoeker: dus ook nu het sitebrede geheugen bijwerken. */
      onthoud(normalized, onthouden);
      return Promise.resolve(onthouden);
    }

    /* Meteen onthouden dat dit het kenteken van deze bezoeker is, nog voor we
       weten wat eruit komt. Loopt de opvraging stuk op de limiet, op een
       storing of op een auto die de dienst niet kent, dan staat het kenteken
       op de volgende pagina evengoed nog in het veld. */
    onthoud(normalized, null);

    /* Blijft het antwoord uit, dan is doorgaan met draaien geen dienst aan de
       bezoeker. Na tien seconden zeggen we dat het langer duurt dan normaal.
       AbortController breekt het verzoek ook echt af, zodat er geen antwoord
       binnenkomt op een scherm dat al iets anders vertelt. */
    var stop = ('AbortController' in window) ? new AbortController() : null;
    var klok = window.setTimeout(function () { if (stop) stop.abort(); }, 10000);

    return fetch(ENDPOINTS.plate +
                 '?kenteken=' + encodeURIComponent(normalized) +
                 '&sessie=' + encodeURIComponent(sessie()), {
      headers: { Accept: 'application/json' },
      signal: stop ? stop.signal : undefined
    }).catch(function (err) {
      window.clearTimeout(klok);
      if (err && err.name === 'AbortError') {
        throw new Error('Het duurt langer dan normaal. Probeer het nog een keer, of bel 0525-796515.');
      }
      throw new Error('De kentekenservice reageert niet. Probeer het zo nog een keer.');
    }).then(function (r) {
      window.clearTimeout(klok);
      if (r.status === 404 || r.status === 429) {
        /* Allebei geen storing maar een antwoord, en in de body staat waarom.
           Bij 404 is dat kan_wel of niet_gevonden - dat verschil is
           commercieel, want kan_wel is een auto die we wel kunnen tunen. Bij
           429 is de bezoeker tegen de limiet gelopen en staat de tekst die hij
           moet zien in het veld fout. In beide gevallen mag hier geen algemene
           storingsmelding uit komen. */
        var code = r.status;
        return r.json().then(
          function (b) { return zonderTreffer(b, code); },
          function () { return zonderTreffer(null, code); }
        ).then(function (v) {
          /* Een 404 is een echt antwoord en heeft evengoed een opvraging
             gekost. Een 429 niet onthouden: die gaat vanzelf weer over. */
          if (code === 404) geheugenSchrijf(normalized, v);
          return v;
        });
      }
      if (!r.ok) throw new Error('De kentekenservice reageert niet. Probeer het zo nog een keer.');
      return r.json().then(function (v) { geheugenSchrijf(normalized, v); return v; });
    });
  }

  /* Antwoord zonder treffer, met de reden erin. gevonden zetten we hier zelf,
     zodat de weergave niet hoeft te gokken of het veld meekwam.             */
  function zonderTreffer(body, code) {
    var b = body && typeof body === 'object' ? body : {};
    b.gevonden = false;
    if (!b.status) b.status = code === 429 ? 'limiet' : 'niet_gevonden';
    return b;
  }

  /* Mock die altijd hetzelfde antwoord geeft voor hetzelfde kenteken, zodat
     de weergave voorspelbaar is tijdens het bouwen en testen.              */
  function mockVehicle(normalized) {
    var voorbeelden = [
      { merk: 'BMW', model: '3 Serie', motorisering: '330i', bouwjaar: 2021, brandstof: 'Benzine',
        vermogen: { origineel: 258, stage1: 330, eenheid: 'pk' }, koppel: { origineel: 400, stage1: 500, eenheid: 'Nm' } },
      { merk: 'Audi', model: 'A3', motorisering: '35 TFSI', bouwjaar: 2020, brandstof: 'Benzine',
        vermogen: { origineel: 150, stage1: 190, eenheid: 'pk' }, koppel: { origineel: 250, stage1: 330, eenheid: 'Nm' } },
      { merk: 'Volkswagen', model: 'Golf', motorisering: 'GTI', bouwjaar: 2022, brandstof: 'Benzine',
        vermogen: { origineel: 245, stage1: 300, eenheid: 'pk' }, koppel: { origineel: 370, stage1: 440, eenheid: 'Nm' } },
      { merk: 'Mercedes-Benz', model: 'C-Klasse', motorisering: 'C 300', bouwjaar: 2019, brandstof: 'Benzine',
        vermogen: { origineel: 258, stage1: 310, eenheid: 'pk' }, koppel: { origineel: 370, stage1: 450, eenheid: 'Nm' } }
    ];
    var som = 0;
    for (var i = 0; i < normalized.length; i++) som += normalized.charCodeAt(i);
    var v = voorbeelden[som % voorbeelden.length];

    return Object.assign({ kenteken: formatPlate(normalized), gevonden: true }, v);
  }

  /**
   * Kentekenopmaak: GX001B wordt GX-001-B.
   * Groepeert per reeks letters of cijfers; reeksen van 4 of langer worden
   * opgeknipt, zoals in het ontwerp.
   * @param {string} value
   * @returns {string}
   */
  function formatPlate(value) {
    var v = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
    var runs = v.match(/[A-Z]+|[0-9]+/g) || [];
    var parts = [];
    runs.forEach(function (r) {
      if (r.length === 4) { parts.push(r.slice(0, 2), r.slice(2)); }
      else if (r.length > 4) { parts.push(r.slice(0, 2), r.slice(2, 4), r.slice(4)); }
      else { parts.push(r); }
    });
    return parts.join('-');
  }

  return {
    getVehicleTree: getVehicleTree,
    lookupPlate: lookupPlate,
    formatPlate: formatPlate,
    laatsteKenteken: laatsteKenteken,
    /* Het kenteken van deze bezoeker, dertig dagen lang: { kt, v, ts } of
       null. v is het volledige antwoord als dat er was. Schrijven gebeurt
       vanzelf bij elke opvraging; onthoudKenteken is er voor het ene geval
       dat het thema meer weet dan de opvraging - de bezoeker die zelf een
       uitvoering aanklikt (assets/df-kenteken.js). */
    onthoudenKenteken: onthoudenKenteken,
    onthoudKenteken: onthoud,
    /* Handig als je bij een klacht over de limiet wilt zien welk kenmerk deze
       browser meestuurt: DFData.sessie() in de console. */
    sessie: sessie
  };
})();
